import { useMutation } from '@apollo/client'
import { SoftwareManagementUpdateEmployeeDocument } from 'generated/resources/graphql'

interface QueryParameters {
  id: number
  phoneNumber: string
}

export const useUpdateEmployee = () => {
  const [updateEmployee, { loading }] = useMutation(SoftwareManagementUpdateEmployeeDocument)

  return {
    updateEmployee(params: QueryParameters) {
      return updateEmployee({ variables: { ...params } })
    },
    loading,
  }
}
